module.exports = __webpack_public_path__ + "webfolder/assets/ebook/ytt-magazine/img/twitter_page3.eaa68f2f.jpg";